import { VIDEO_STATUS, VIDEO_URL, VIDEO_RESET } from 'constants/actionTypes';

const setVideoStatus = (status, method) => {
    return {
        type: VIDEO_STATUS,
        status,
        method,
    };
};

const setVideoUrl = url => {
    return {
        type: VIDEO_URL,
        url,
    };
};

const videoReset = () => {
    return {
        type: VIDEO_RESET,
    };
};

export { videoReset, setVideoStatus, setVideoUrl };
